import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { watchBloqueados } from "@/data/moderacao";
import { useSession } from "./auth";

/* ============================================================
   Quem esta pessoa bloqueou, disponível em qualquer tela

   Um contexto, e não uma assinatura por tela: o feed, o prato e o
   bate-papo filtram a mesma lista, e três assinaturas da mesma coleção
   seriam três leituras para responder a mesma pergunta.

   Bloquear tem que ESCONDER de verdade — é o que a loja cobra, e é o
   que a pessoa espera. Esconder só o perfil e deixar os pratos no feed
   não é bloqueio, é configuração.
   ============================================================ */

const Contexto = createContext<Set<string>>(new Set());

export function BloqueiosProvider({ children }: { children: ReactNode }) {
  const { user } = useSession();
  const [bloqueados, setBloqueados] = useState<Set<string>>(new Set());

  const uid = user?.uid;
  useEffect(() => {
    if (!uid) { setBloqueados(new Set()); return; }
    return watchBloqueados(uid, setBloqueados);
  }, [uid]);

  return <Contexto.Provider value={bloqueados}>{children}</Contexto.Provider>;
}

export const useBloqueados = (): Set<string> => useContext(Contexto);

/** Filtra qualquer lista que tenha autor. */
export function semBloqueados<T extends { uid: string }>(
  lista: readonly T[], bloqueados: Set<string>,
): T[] {
  if (!bloqueados.size) return lista as T[];
  return lista.filter((item) => !bloqueados.has(item.uid));
}
